import React, { useEffect } from "react";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";

import Option from "../../Cell/Option";

import IntlMessage from "../../../LocaleEngine";
import { gtmFunction } from '../../../utils/ga';
import { getSystemSettings } from "../../../utils/SettingsRetriever";

export default function ListOptions(props) {
  const systemSettings = getSystemSettings();
  const { new_rental_system } = systemSettings;
  useEffect(() => {
    if (props.list && props.list.length > 0) {
        gtmFunction("view_item_list", props.list, getListTitle(), getListTitle())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getListTitle = () => {
    if (props.configuration && props.configuration.title) return props.configuration.title;
    if (props.componentName) return props.componentName
    return ""
  }

  if (!props.list) {
    return <IntlMessage id="activities.list.options.no_options_available" />;
  }

  if (props.list && props.list.length <= 0) {
    return <IntlMessage id="activities.list.options.no_options_available" />;
  }

  const addToCart = (element, amount, callback, amountOfDays) => {
    props.addToCart(element, amount, callback, amountOfDays);
  };

  const Price = (a, b, reverse = false) => {
    if (a.Price < b.Price) {
      return reverse ? 1 : -1;
    }
    if (a.Price > b.Price) {
      return reverse ? -1 : 1;
    }
    return 0;
  };

  const DisplaySeq = (a, b, reverse = false) => {
    if (a.DisplaySeq < b.DisplaySeq) {
      return reverse ? 1 : -1;
    }
    if (a.DisplaySeq > b.DisplaySeq) {
       return reverse ? -1 : 1;
    }
    return 0;
  };

  const SortRank = (a, b, reverse = false) => {
    if (a.SortRank < b.SortRank) {
      return reverse ? 1 : -1;
    }
    if (a.SortRank > b.SortRank) {
       return reverse ? -1 : 1;
    }
    return 0;
  };

  const AZ = (a, b, reverse = false) => {
    if (a.ProductName < b.ProductName) {
      return reverse ? 1 : -1;
    }
    if (a.ProductName > b.ProductName) {
       return reverse ? -1 : 1;
    }
    return 0;
  };
  const internalOrder = (list, order) => {
    switch (order) {
      case "A-Z":
        list.sort(AZ);
        break;
      case "Z-A":
        list.sort((a, b) => AZ(a, b, true));
        break;
      case "Price":
        list.sort(Price);
        break;
      case "-Price":
        list.sort((a, b) => Price(a, b, true));
        break;
      case "DisplaySeq":
        list.sort(DisplaySeq);
        break;
      case "-DisplaySeq":
        list.sort((a, b) => DisplaySeq(a, b, true));
        break;
      case "SortRank":
        list.sort(SortRank);
        break;
      case "-SortRank":
        list.sort((a, b) => SortRank(a, b, true));
        break;
      default:
        list.sort(Price);
        break;
    }
    return list;
  };
  
  let orderedList = props.configuration && props.configuration.config
    ? internalOrder(props.list, props.configuration.config.defaultItemSort)
    : props.list;
  
  const rentalPopup = props.configuration && props.configuration.config && props.configuration.config.rentalPopup;
  const rentalPopupIsEnabled = rentalPopup && rentalPopup.enabled && (!rentalPopup.productCategories || rentalPopup.productCategories.find(cat => cat === props.productCategoryId));

  return (
    <Grid container spacing={0} className="options">
      <div className="headers">
        <h4 className="title">
          <IntlMessage id="activities.cell.option.head.product" />
        </h4>
        {props.compact ? null : (
          <h4 className="date">
            <IntlMessage id="activities.cell.option.head.date" />
          </h4>
        )}
        {
          rentalPopupIsEnabled ? 
          <div className="tooltip">
            <h4 className="amount">
              <IntlMessage id="activities.cell.option.head.qty" />
            </h4>
            <span className="tooltip-text">{rentalPopup.message}</span>
          </div>
          : null
        }
        {props.quantityPicker || rentalPopupIsEnabled ? null : (
          <h4 className="amount">
            <IntlMessage id="activities.cell.option.head.qty" />
          </h4>
        )}
        {
          new_rental_system && new_rental_system.enabled && new_rental_system.suppliers.find(supplier => props.list && props.list[0] && supplier === props.list[0].SupplierId) ?
          <h4 className="amount">
            <IntlMessage id="DAYS" />
          </h4>
          : null
        }
        <h4 className="price">
          <IntlMessage id="activities.cell.option.head.price" />
        </h4>
      </div>
      <div className="values">
        {orderedList.map((element, index) => {
          let isLast = false;
          if (index + 1 === props.list.length) isLast = true;

          return (
            <React.Fragment key={index}>
              <Option
                packageCart={props.packageCart}
                addQuantity={props.addQuantity}
                reduceQuantity={props.reduceQuantity}
                quantityPicker={props.quantityPicker}
                configuration={props.configuration}
                minQuantity={props.minQuantity}
                maxQuantity={props.maxQuantity}
                dateOfActivity={props.dateOfActivity}
                isPackage={props.isPackage}
                displayType={props.displayType}
                compact={props.compact}
                addToCart={addToCart.bind(this)}
                date={true}
                element={element}
              />
              {!isLast && <Divider />}
            </React.Fragment>
          );
        })}
      </div>
    </Grid>
  );
}
